<div class="heading">{{ title }}</div>
<!-- @if (title !='Winding Temperature') {

<div class="inner vibrationInner" style="justify-content: center">
  <app-radial-gauge
    *ngIf="data && data.length > 0"
    matTooltip="Oil Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
    [matTooltipClass]="'tooltip'"
    [ngClass]="'custom-css'"
    [inputData]="data"
  >
  </app-radial-gauge>
</div>
<button
  *ngIf="role !== 'OEM'"
  (click)="openExformerGraphSettingsDialog('OilTemperature', 1457)"
  class="setting_btn_tf"
>
  <img src="./assets/settings.png" />
</button>
} @if(title =='Winding Temperature') {
<div class="windTemp" style="justify-content: space-around !important">
  <div
    class="inner vibrationInner"
    *ngFor="let windingTemperature of tXformerWendingTemperatureData"
  >
    <ng-container *ngIf="windingtemperatureloading; else windingTemperatureid">
      <div class="spinner-container charts-loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    </ng-container>
    <ng-template #windingTemperatureid>
      <app-gauge-chart
        matTooltip=" Winding Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
        style="color: orange; color: black"
        [canvasWidth]="160"
        [canvasHeight]="140"
        [matTooltipClass]="'tooltip'"
        [ngClass]="'custom-css'"
        [canvasWidth]="160"
        [needleValue]="windingTemperature.needleValue"
        [needleColor]="windingTemperature.options.needleColor"
        [centralLabel]="centralLabel"
        [options]="windingTemperature.options"
        [name]="windingTemperature.name"
        [bottomLabel]="windingTemperature.bottomLabel"
      >
      </app-gauge-chart>
    </ng-template>
  </div>
</div>
<button
  mat-button
  *ngIf="role !== 'OEM'"
  (click)="openExformerGraphSettingsDialog('WindingTemperature', 1457)"
  class="setting_btn_tf"
>
  <img src="./assets/settings.png" />
</button>
} -->

<div class="windTemp" style="justify-content: space-around !important">
  <div
    class="inner vibrationInner"
    *ngFor="let d of data"
  >
    <ng-container *ngIf="loading; else elseBlock">
      <div class="spinner-container charts-loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    </ng-container>
    <ng-template #elseBlock>
      <app-gauge-chart
        matTooltip=" Winding Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
        style="color: orange; color: black"
        [canvasWidth]="160"
        [canvasHeight]="140"
        [matTooltipClass]="'tooltip'"
        [ngClass]="'custom-css'"
        [canvasWidth]="160"
        [needleValue]="d.needleValue"
        [needleColor]="d.options.needleColor"
        [centralLabel]="centralLabel"
        [options]="d.options"
        [bottomLabel]="d.bottomLabel"
        >
        <!-- [name]="d.name" -->
      </app-gauge-chart>
    </ng-template>
  </div>
</div>
<!-- <button
    mat-button
    *ngIf="role !== 'OEM'"
    (click)="openExformerGraphSettingsDialog('WindingTemperature', 1457)"
    class="setting_btn_tf"
  >
    <img src="./assets/settings.png" />
  </button> -->
